import { useState, useEffect } from 'react';
import AdminLayout from './components/layouts/AdminLayout';
import DashboardOverview from './components/admin/DashboardOverview';
import UserManagement from './components/admin/UserManagement';
import ActivityLog from './components/admin/ActivityLog';
import AdmissionsReport from './components/admin/AdmissionsReport';
import './styles/dashboard.css';

function SuperAdminDashboard({ user, onLogout, apiBase }) {
  const [activeTab, setActiveTab] = useState('overview');
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const [unreadActivities, setUnreadActivities] = useState(0);

  useEffect(() => {
    const checkActivities = async () => {
      try {
        const response = await fetch(`${apiBase}/admin/update-history`, {
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
        });
        
        if (response.ok) {
          const data = await response.json();
          if (data.ok && Array.isArray(data.data)) {
            setUnreadActivities(data.data.length > 0 ? data.data.length : 0);
          }
        }
      } catch (err) {
        console.error('Error checking activities:', err);
      }
    };

    checkActivities();
    const interval = setInterval(checkActivities, 30000);
    return () => clearInterval(interval);
  }, [apiBase]);

  const handleLogout = async () => {
    if (window.confirm('Anda yakin ingin logout?')) {
      try {
        await fetch(`${apiBase}/auth/logout`, {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
        });
      } catch (err) {
        console.error('Logout error:', err);
      }
      onLogout();
    }
  };

  const menuItems = [
    // HIDDEN: Dashboard, Activity Log, Admissions Report - only show Users
    { 
      id: 'users', 
      label: 'Users',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      )
    }
  ];

  const roleColor = '#667eea'; // Purple for Super Admin
  const dashboardTitle = 'Super Admin';

  return (
    <AdminLayout
      user={user}
      onLogout={onLogout}
      roleColor={roleColor}
      dashboardTitle={dashboardTitle}
      menuItems={menuItems}
      activeTab={activeTab}
      onTabChange={setActiveTab}
      apiBase={apiBase}
    >
      <div className="dashboard-content">
        {activeTab === 'overview' && (
          <DashboardOverview apiBase={apiBase} />
        )}

        {activeTab === 'users' && (
          <UserManagement apiBase={apiBase} />
        )}

        {activeTab === 'activities' && (
          <ActivityLog apiBase={apiBase} />
        )}

        {activeTab === 'admissions' && (
          <AdmissionsReport apiBase={apiBase} />
        )}
      </div>
    </AdminLayout>
  );
}

export default SuperAdminDashboard;
